import React from 'react';
import { Switch, Route } from 'react-router-dom';
import { combineReducers } from 'redux';

// Components
import TrialVoucher from './TrialVoucher';


// Reducers
import trialVoucherReducer from './TrialVoucher/store/trialVoucherReducer';


// Routes
export const routes = (basePath, permissions) =>
    <Switch>
        {<Route path={basePath} exact component={TrialVoucher} />}
    </Switch>


export const reducers = combineReducers({
    trialVouchers: trialVoucherReducer
});